export const muiKey = process.env.REACT_APP_LICENSE_KEY || '';
